import React from 'react';
import { APP_BASENAME } from './appNavigation';
import EmbeddedWorkspaceBridge from './EmbeddedWorkspaceBridge';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import AppLayout from './AppLayout';
import Overview from './Overview';    // This will be our updated Overview component
import Profile from './Profile';
import ChangeEmailPage from './ChangeEmailPage';
import ReauthenticatePage from './ReauthenticatePage';
import NewPasswordPage from './NewPasswordPage';
import ResetPasswordPage from './ResetPasswordPage';
import ProtectedRoute from './ProtectedRoute';
import DeleteAccountConfirmPage from './DeleteAccountConfirmPage';
import McpAccess from './McpAccess';
import { AuthProvider } from './AuthContext';
import AppHomeRedirect from './AppHomeRedirect';
import { LanguageProvider } from './i18n';
import AnalyticsRouteTracker from './AnalyticsRouteTracker';
import AuthCallbackNotice from './AuthCallbackNotice';
import AppErrorBoundary from './AppErrorBoundary';
import './App.css';  // Make sure to use the updated App.css
import './Workspace.css';

// The integrated build does not import the admin dashboard.
const AdminDashboard = process.env.REACT_APP_ROUTER_BASENAME === '/app'
  ? null
  : React.lazy(() => import('./AdminDashboard'));

function App() {
  return (
    <LanguageProvider>
      <AppErrorBoundary>
      <AuthProvider>
        <Router basename={APP_BASENAME || undefined}>
          <EmbeddedWorkspaceBridge />
          <AuthCallbackNotice />
          <AnalyticsRouteTracker />
          <Routes>
            <Route path="/" element={<AppHomeRedirect />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/mcp/authorize" element={<ProtectedRoute><McpAccess /></ProtectedRoute>} />
            <Route path="/mcp/connections" element={<ProtectedRoute><McpAccess /></ProtectedRoute>} />
            <Route path="/desktop/authorize" element={<ProtectedRoute><McpAccess kind="desktop" /></ProtectedRoute>} />
            <Route path="/desktop/connections" element={<ProtectedRoute><McpAccess kind="desktop" /></ProtectedRoute>} />

            <Route path="/dashboard" element={<AppLayout />}>
              <Route index element={<ProtectedRoute requireAuth={false}><AppErrorBoundary component="Overview"><Overview /></AppErrorBoundary></ProtectedRoute>} />
              <Route path="overview" element={<ProtectedRoute requireAuth={false}><AppErrorBoundary component="Overview"><Overview /></AppErrorBoundary></ProtectedRoute>} />
              <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="reauthenticate" element={<ProtectedRoute><ReauthenticatePage /></ProtectedRoute>} />
              <Route path="new-password" element={<ProtectedRoute><NewPasswordPage /></ProtectedRoute>} />
              <Route path="change-email" element={<ProtectedRoute><ChangeEmailPage /></ProtectedRoute>} />
              <Route path="delete-account-confirm" element={<ProtectedRoute><DeleteAccountConfirmPage /></ProtectedRoute>} />
            </Route>

            {AdminDashboard && (
              <Route path="/admin" element={<AppLayout />}>
                <Route index element={<ProtectedRoute><React.Suspense fallback={<div>Loading...</div>}><AdminDashboard /></React.Suspense></ProtectedRoute>} />
              </Route>
            )}
          </Routes>
        </Router>
      </AuthProvider>
      </AppErrorBoundary>
    </LanguageProvider>
  );
}

export default App;
